<template>
  <div class="h-auto w-full mr-3 my-3">
    <div class="bg-white mx-3 rounded-b-md">
      <el-tabs type="border-card" @tab-click="(e) => setTab(e)">
        <el-tab-pane
          v-for="(tab, index) in tabs"
          :key="index"
          :label="tab.name"
        >
          <div v-if="tab.name === 'Document Classifications'">
            <div class="border-b-0.5 flex justify-between items-center p-2">
              <p class="text-sm font-semibold w-full">List of {{ tab.name }}</p>
            </div>
            <div class="flex justify-between items-center p-2">
              <el-pagination
                background
                @size-change="handleSizeChange"
                :page-sizes="pageSizes"
                :page-index="pageIndex"
                :page-size="pageSize"
                layout="sizes"
                :total="currentTableData.length"
              >
              </el-pagination>

              <!-- search -->
              <input
                v-model="searchInput"
                type="search"
                placeholder="Start typing to search..."
                class="bg-gray-200 w-52 py-1 rounded-md"
              />
              <!-- search -->
              <div class="flex flex-wrap justify-end w-full gap-3">
                <button
                  @click="showCreateDocumentClassification = true"
                  class="border-1.5 rounded-full px-2 py-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary items-center flex gap-1 capitalize"
                >
                  <svg
                    id="Layer_1"
                    height="20"
                    viewBox="0 0 24 24"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    data-name="Layer 1"
                    fill="#fff"
                  >
                    <path
                      d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
                    />
                  </svg>
                  Create
                </button>
              </div>
            </div>
            <div class="px-2 pb-2">
              <transition name="fade">
                <div
                  v-if="loading"
                  class="inset-0 absolute z-50 bg-white w-full"
                >
                  <loader class="center-h-v" />
                </div>
              </transition>

              <transition name="fade">
                <div
                  v-if="del_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ del_error }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="get_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ get_error }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="create_success"
                  class="p-1 text-center text-sm w-full bg-green-200"
                >
                  {{ create_success }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="del_document"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ del_document }}
                </div>
              </transition>
              <div>
                <ve-table
                  v-if="searchInput"
                  :columns="classificationColumns"
                  :table-data="filteredTableData"
                  sort-order="asc"
                />

                <ve-table
                  :columns="classificationColumns"
                  :tableData="currentTableData"
                  v-if="!searchInput.length"
                >
                </ve-table>

                <p
                  v-if="searchInput.length && filteredTableData.length === 0"
                  class="text-center py-3"
                >
                  No results
                </p>

                <p
                  v-if="tableData.length == 0 && !loading && !get_error"
                  class="p-1 text-center text-sm w-full bg-gray-100"
                >
                  No documents found
                </p>
                <!-- Pagination -->
                <div class="table-pagination text-center mt-2">
                  <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange"
                  >
                    <!-- :current-page.sync="currentPage4" -->
                  </el-pagination>
                </div>
                <!-- Pagination -->
              </div>
            </div>
          </div>

          <div v-if="tab.name === 'Employee Documents'">
            <div class="border-b-0.5 flex justify-between items-center p-2">
              <p class="text-sm font-semibold w-full">List of {{ tab.name }}</p>
            </div>
            <div class="flex justify-between items-center p-2">
              <el-pagination
                background
                @size-change="handleSizeChange"
                :page-sizes="pageSizes"
                :page-index="pageIndex"
                :page-size="pageSize"
                layout="sizes"
                :total="currentTableData.length"
              >
              </el-pagination>

              <!-- search -->
              <input
                v-model="searchInput"
                type="search"
                placeholder="Start typing to search..."
                class="bg-gray-200 w-52 py-1 rounded-md"
              />
              <!-- search -->
              <div class="flex flex-wrap justify-end w-full gap-3">
                <button
                  @click="showCreateDocument = true"
                  class="border-1.5 rounded-full px-2 py-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
                >
                  <svg
                    id="Layer_1"
                    height="20"
                    viewBox="0 0 24 24"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    data-name="Layer 1"
                    fill="#fff"
                  >
                    <path
                      d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
                    />
                  </svg>
                  Create
                </button>
              </div>
            </div>
            <div class="px-2 pb-2">
              <transition name="fade">
                <div
                  v-if="loading"
                  class="inset-0 absolute z-50 bg-white w-full"
                >
                  <loader class="center-h-v" />
                </div>
              </transition>

              <transition name="fade">
                <div
                  v-if="del_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ del_error }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="get_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ get_error }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="create_success"
                  class="p-1 text-center text-sm w-full bg-green-200"
                >
                  {{ create_success }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="del_document"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ del_document }}
                </div>
              </transition>
              <div>
                <ve-table
                  v-if="searchInput"
                  :columns="columns"
                  :table-data="filteredTableData"
                  sort-order="asc"
                />

                <ve-table
                  :columns="columns"
                  :tableData="currentTableData"
                  v-if="!searchInput.length"
                >
                </ve-table>

                <p
                  v-if="searchInput.length && filteredTableData.length === 0"
                  class="text-center py-3"
                >
                  No results
                </p>

                <p
                  v-if="tableData.length == 0 && !loading && !get_error"
                  class="p-1 text-center text-sm w-full bg-gray-100"
                >
                  No documents found
                </p>
                <!-- Pagination -->
                <div class="table-pagination text-center mt-2">
                  <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange"
                  >
                    <!-- :current-page.sync="currentPage4" -->
                  </el-pagination>
                </div>
                <!-- Pagination -->
              </div>
            </div>
          </div>

          <div v-if="tab.name === 'Knowledge Base Documents'">
            <div class="border-b-0.5 flex justify-between items-center p-2">
              <p class="text-sm font-semibold w-full">List of {{ tab.name }}</p>
            </div>
            <div class="flex justify-between items-center p-2">
              <el-pagination
                background
                @size-change="handleSizeChange"
                :page-sizes="pageSizes"
                :page-index="pageIndex"
                :page-size="pageSize"
                layout="sizes"
                :total="currentTableData.length"
              >
              </el-pagination>

              <!-- search -->
              <input
                v-model="searchInput"
                type="search"
                placeholder="Start typing to search..."
                class="bg-gray-200 w-52 py-1 rounded-md"
              />
              <!-- search -->
              <div class="flex flex-wrap justify-end w-full gap-3">
                <button
                  @click="showCreateKnowledgeDocument = true"
                  class="border-1.5 rounded-full px-2 py-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
                >
                  <svg
                    id="Layer_1"
                    height="20"
                    viewBox="0 0 24 24"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    data-name="Layer 1"
                    fill="#fff"
                  >
                    <path
                      d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
                    />
                  </svg>
                  Create
                </button>
              </div>
            </div>
            <div class="px-2 pb-2">
              <transition name="fade">
                <div
                  v-if="loading"
                  class="inset-0 absolute z-50 bg-white w-full"
                >
                  <loader class="center-h-v" />
                </div>
              </transition>

              <transition name="fade">
                <div
                  v-if="del_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ del_error }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="get_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ get_error }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="create_success"
                  class="p-1 text-center text-sm w-full bg-green-200"
                >
                  {{ create_success }}
                </div>
              </transition>
              <transition name="fade">
                <div
                  v-if="del_document"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
                >
                  {{ del_document }}
                </div>
              </transition>
              <div>
                <ve-table
                  v-if="searchInput"
                  :columns="knowledgeBaseColumns"
                  :table-data="filteredTableData"
                  sort-order="asc"
                />

                <ve-table
                  :columns="knowledgeBaseColumns"
                  :tableData="currentTableData"
                  v-if="!searchInput.length"
                >
                </ve-table>

                <p
                  v-if="searchInput.length && filteredTableData.length === 0"
                  class="text-center py-3"
                >
                  No results
                </p>

                <p
                  v-if="tableData.length == 0 && !loading && !get_error"
                  class="p-1 text-center text-sm w-full bg-gray-100"
                >
                  No documents found
                </p>
                <!-- Pagination -->
                <div class="table-pagination text-center mt-2">
                  <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    @current-change="handleCurrentChange"
                  >
                    <!-- :current-page.sync="currentPage4" -->
                  </el-pagination>
                </div>
                <!-- Pagination -->
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- create -->
    <CreateKnowledgeDocs
      @close="showCreateKnowledgeDocument = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :showCreateKnowledgeDocument="showCreateKnowledgeDocument"
      :reload="reload"
    >
    </CreateKnowledgeDocs>

    <CreateDocument
      @close="showCreateDocument = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :showCreateDocument="showCreateDocument"
      :reload="reload"
      :documentClassifications="documentClassifications"
    >
    </CreateDocument>

    <!-- edit -->
    <EditDocument
      @close="handleClose"
      :info="documentToEdit"
      :showEditDocument="showEditDocument"
      :documentClassifications="documentClassifications"
      :reload="reload"
    >
    </EditDocument>

    <CreateDocumentClassification
      @close="showCreateDocumentClassification = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :showCreateDocumentClassification="showCreateDocumentClassification"
      :reload="reload"
    >
    </CreateDocumentClassification>

    <!-- edit -->
    <EditDocumentClassification
      @close="handleClose"
      :info="documentToEdit"
      :showEditDocumentClassification="showEditDocumentClassification"
      :reload="reload"
    >
    </EditDocumentClassification>

    <EditKnowledgeDocument
      @close="handleClose"
      :info="documentToEdit"
      :showEditKnowledgeDocument="showEditKnowledgeDocument"
      :reload="reload"
    >
    </EditKnowledgeDocument>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import axios from "axios";
import CreateDocument from "@/components/CompanySetups/documentsSetups/create.vue";
import EditDocument from "@/components/CompanySetups/documentsSetups/editDocument.vue";
import CreateDocumentClassification from "@/components/CompanySetups/documentsSetups/createDocumentClassification.vue";
import EditDocumentClassification from "@/components/CompanySetups/documentsSetups/editDocumentClassification.vue";
import EditKnowledgeDocument from "@/components/CompanySetups/documentsSetups/editKnowledgeDocument.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
import CreateKnowledgeDocs from "./createKnowledgeDocs.vue";

export default {
  name: "documentsList",
  components: {
    Loader,
    CreateDocument,
    ActionWarning,
    EditDocument,
    CreateKnowledgeDocs,
    EditKnowledgeDocument,
    CreateDocumentClassification,
    EditDocumentClassification,
  },

  data() {
    return {
      currentTab: "classification",
      tabs: [
        { name: "Document Classifications", route: "employee-documents" },
        { name: "Employee Documents", route: "employee-documents" },
        { name: "Knowledge Base Documents", route: "knowledge-base" },
      ],
      url: "",
      title: "Document List",
      showBulkUpload: false,

      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      documentClassifications: [],
      resultColumns: [],
      showCreateDocument: false,
      showCreateKnowledgeDocument: false,
      showEditDocument: false,
      showEditDocumentClassification: false,
      showCreateDocumentClassification: false,
      showEditKnowledgeDocument: false,
      loading: false,
      get_error: null,
      create_success: null,
      del_document: null,
      del_error: null,
      info: null,
      message: null,

      searchInput: "",
      showActions: false,
      documentToDelete: null,
      showWarning: false,
      documentToEdit: {},
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "name",
          title: "Name",
          sampleValue: "HelbClearance",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => (
            <div
              //on-click={() => this.viewJournal(row)}
              class="flex gap-5 items-center"
            >
              <p class="text-blue-500 cursor-pointer">{row.Name}</p>
            </div>
          ),
        },
        {
          field: "DocumentClassification",
          key: "DocumentClassification",
          title: "Classification",
          headerAlign: "center",
          sampleValue: "official",
          align: "left",
        },
        {
          field: "IsRequired",
          key: "IsRequired",
          title: "Required",
          headerAlign: "center",
          align: "center",
          sampleValue: "TRUE",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.IsRequired}></VeCheckbox>
          ),
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      knowledgeBaseColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "Name",
          title: "Name",
          headerAlign: "left",
          sampleValue: "policy",
          align: "left",
        },
        {
          field: "Description",
          key: "Description",
          title: "Description",
          sampleValue: "Policy Document",
          headerAlign: "left",
          align: "left",

          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },
        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      classificationColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "Name",
          title: "Name",
          headerAlign: "left",
          sampleValue: "classification",
          align: "left",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        const data = this.tableData;
        return data.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;

      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },

    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getDocuments();
    this.setPageSizes();
    this.getDocumentClassifications();
  },
  methods: {
    setTab(event) {
      let tabId;
      if (event["$el"]) {
        const { id } = event["$el"];
        tabId = id;
      } else {
        tabId = event;
      }
      switch (tabId) {
        case "pane-0":
          this.currentTab = "classification";
          this.getDocuments();
          break;
        case "pane-1":
          this.currentTab = "employee";
          this.getDocuments();
          break;
        case "pane-2":
          this.currentTab = "knowledge";
          this.getDocuments();
          break;
      }
    },
    reload() {
      this.getDocuments();
      this.showEditDocument = false;
      this.showCreateDocument = false;
      this.showEditKnowledgeDocument = false;
      this.showCreateKnowledgeDocument = false;
      this.showCreateDocumentClassification = false;
      this.showEditDocumentClassification = false;
      setTimeout(() => {
        this.showAssetBulkUpload = false;
      }, 3000);
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
    },
    close() {
      this.showBulkUpload = false;
      this.$emit("close");
    },
    showBulkUploadForm() {
      this.resultColumns = this.columns.filter((col) => col.title !== "Action");
      this.showBulkUpload = true;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleEditButtonClick(document) {
      console.log(this.currentTab)
      switch (this.currentTab) {
        case "classification":
          this.documentToEdit = {
            DocClassificationId: document.Id,
            Name: document.Name,
          };
          this.showEditDocumentClassification = true;
          break;
        case "employee":
          this.documentToEdit = {
            DocumentTypeId: document.DocumentTypeId,
            DocumentClassification: document.DocumentClassification,
            DocClassificationId: document.DocClassificationId,
            Name: document.Name,
            IsRequired: document.IsRequired,
            Description: document.Description,
          };
          this.showEditDocument = true;
          break;
        case "knowledge":
          this.documentToEdit = {
            knowledgebaseCategoryId: document.Id,
            Name: document.Name,
            Description: document.Description,
          };
          this.showEditKnowledgeDocument = true;
          break;
        default:
          break;
      }
    },
    handleDeleteButtonClick(document) {
      // Handle the button click for the delete button
      //console.log(document)
      this.title = `Delete ${document.Name}`;
      this.message = `You are about to delete ${document.Name} from the documents list!`;
      this.documentToDelete = document;
      //console.log(this.documentToDelete)
      this.showWarning = true;
    },
    setIsConfirmed() {
      this.showWarning = false;
      if (this.documentToDelete) {
        this.deleteDocument(this.documentToDelete);
        return;
      }
    },
    exportTemplate() {
      this.filteredTabs = this.columns.filter(
        (column) => column.title !== "Action"
      );
      importTemplateGenerator(
        this.filteredTabs,

        "Document List"
      );
    },
    handleClose() {
      this.showCreateDocument = false;
      this.showEditDocument = false;
      this.showEditKnowledgeDocument = false;
    },
    handleCloseOnSuccess() {
      this.showCreateDocument = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getDocuments();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.showLocDelSuccess = null;
      }, 3000);
      this.getDocuments();
    },

    Adddocument(row) {
      this.selectedRow = row;
      this.showAdddocument = true;
    },

    handleCloseOnAddDept() {
      this.showAdddocument = false;
      this.showAdddocumentSuccess = true;
      setTimeout(() => {
        this.showAdddocumentSuccess = false;
      }, 3000);
    },

    // /{organization}/setup/document/type/v1/request
    getDocuments() {
      this.loading = true;
      let url = `${this.getOrganization}/setup/document/classification/${this.$ApiVersion}/request`;

      switch (this.currentTab) {
        case "employee":
          url = `${this.getOrganization}/setup/document/type/${this.$ApiVersion}/request`;

          break;
        case "knowledge":
          url = `${this.getOrganization}/setup/knowledgebase/category/${this.$ApiVersion}/request`;

          break;
        default:
          break;
      }
      // /{organization}/setup/document/classification/v1/request
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            //console.log(response.data.Data);
            this.tableData = response.data.Data;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },

    getDocumentClassifications() {
      this.loading = true;
      let url = `${this.getOrganization}/setup/document/classification/${this.$ApiVersion}/request`;

      // /{organization}/setup/document/classification/v1/request
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.documentClassifications = response.data.Data;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },

    deleteDocument(row) {
      let url = `${this.getOrganization}/setup/document/classification/${this.$ApiVersion}/delete`;

      switch (this.currentTab) {
        case "employee":
          url = `${this.getOrganization}/setup/document/type/${row.DocumentTypeId}/v1/delete`;

          break;
        case "knowledge":
          url = `${this.getOrganization}/setup/knowledgebase/category/${this.$ApiVersion}/delete`;

          break;
        default:
          break;
      }

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          [this.currentTab === "knowledge"
            ? "knowledgebaseCategoryId"
            : "DocClassificationId"]: row.Id,
        },
      };
      axios
        .delete(
          url,

          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.showLocDelSuccess = response.data.StatusMessage;
              this.handleDeleteOnSuccess();
              // this.getDocuments()
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}
</style>
